import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { ButtonLink } from '@/styles/theme/default/buttons';
import {
  BodyFive,
  SubtitleTwo
} from '@/styles/theme/default/typography';
import Icon from '../../Icon';
import useSale  from '@/hooks/useSale';
import {useSelector} from "react-redux";

const Wrapper = styled.div`
  padding: 20px;

  .sale-details-title {
    margin-bottom: 20px;
  }

  .close-icon-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .close-icon {
    cursor: pointer;
  }

  li {
    margin-bottom: 20px;
  }

  .btn-link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;

    .btn-link {
      width: 150px;
    }
  }
`;

function SaleDetailsPopup({ open, toggle }) {
  const { code, saleEnd, saleStage } = useSale();

  const user = useSelector(state => state.Auth.user);
  const isTrade = [2].includes(parseInt(user.role_id));
  // const isTrade = true;

  return (
    <Modal
      className="SaleDetailsModal"
      overlayClassName="ModalUfcOverlay"
      ariaHideApp={false}
      closeTimeoutMS={500}
      isOpen={open}
      onRequestClose={toggle}
    >
      <Wrapper>
        <div className="close-icon-container">
          <Icon
            onClick={toggle}
            className="close-icon"
            icon="ti-close-x"
            size={20}
            color="black"
          />
        </div>
        <div className="content">
          {/*<SubtitleTwo className="sale-details-title" bold>*/}
          {/*  {saleStage === 'regular' ?*/}
          {/*                  'SHOP THE END OF SUMMER SALE AND USE CODE AUGSALE23 TO SAVE 15% OFF ORDERS UNDER $499 OR 20% OFF ORDERS $499+.' :*/}
          {/*    (saleStage === 'surpriseExtension' ? 'Last chance to shop our End of Summer Sale. Use code AUGSALE23 to save 15% off orders under $499 or 20% off orders $499+.' : 'Last day to shop our End of Summer Sale. Use code AUGSALE23 to save 15% off orders under $499 or 20% off orders $499+.')*/}
          {/*                  }*/}
          {/*</SubtitleTwo>*/}
          <BodyFive>
            {/*Use code <strong>{code}</strong> for 20% off orders under $799 and 25% off orders $799+.*/}
          </BodyFive>
          <br/>
          <BodyFive>
            {isTrade ?
              'Offer valid for up to 30% off for Trade Program members. No code needed. Specific discount is noted on the product pages for each item. Promotions cannot be combined or applied to past purchases. Promotions can only be applied to purchases on theinside.com. Offer applies to cart before shipping and tax. Select non-upholstered items, rugs, and lighting are excluded from this promotion with the prices as marked: Accent & End Tables, Nightstands, Non-Upholstered Dining Chairs & Stools. Expires Sunday, 6/22/25 at 11:59pm MT.'
              :
              'Offer valid for 25% off. No code needed. Promotions cannot be combined or applied to past purchases. Promotions can only be applied to purchases on theinside.com. Offer applies to cart before shipping and tax. Select non-upholstered items, rugs, and lighting are excluded from this promotion with the prices as marked: Accent & End Tables, Nightstands, Non-Upholstered Dining Chairs & Stools. Expires Sunday, 6/22/25 at 11:59pm MT.'
            }
            {/*{saleStage === 'surpriseExtension' ? '  Expires Monday, 6/2/25 at 11:59pm MT.' : ' Expires Tuesday, 5/27/25 at 11:59pm MT. '}*/}
          </BodyFive>
          <div className="btn-link-container">
            <ButtonLink
              dark={true}
              className="btn-link"
              to="/categories"
              onClick={toggle}
            >
              Shop Now
            </ButtonLink>
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
}

function formatDate(date, minus = 0) {
  const format = "cccc, L/dd 'at' hh:mm a 'MT'";

  return date
    .setZone('America/Denver')
    .minus({ minutes: minus })
    .toFormat(format);
}

export default SaleDetailsPopup;
